import React, { useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";
import { useInput, useLoop, Joystick, Token, clamp } from "./arena";

const SURVIVE = 25;

// Chhupan-Chhupai: you are hiding. Move to dodge the seeker's sweeping torch beam. Stay out of the light!
export default function ChhupanChhupai() {
  const [phase, setPhase] = useState("ready");
  const [time, setTime] = useState(0);
  const [det, setDet] = useState(0);
  const [, setTick] = useState(0);
  const player = useRef({ x: 50, y: 82 });
  const beam = useRef({ x: 50, dir: 1, sp: 42 });
  const { dir, setJoy } = useInput();

  const start = () => { player.current = { x: 50, y: 82 }; beam.current = { x: 50, dir: 1, sp: 42 }; setTime(0); setDet(0); setPhase("play"); };

  useLoop(phase === "play", (dt) => {
    const p = player.current, b = beam.current, d = dir();
    p.x = clamp(p.x + d.x * 46 * dt, 4, 96);
    p.y = clamp(p.y + d.y * 30 * dt, 55, 94);
    b.x += b.dir * b.sp * dt;
    if (b.x > 92) { b.x = 92; b.dir = -1; b.sp = 40 + Math.random() * 40; }
    if (b.x < 8) { b.x = 8; b.dir = 1; b.sp = 40 + Math.random() * 40; }
    const lit = Math.abs(p.x - b.x) < 9;
    setDet((v) => { const nv = clamp(v + (lit ? 55 : -35) * dt, 0, 100); if (nv >= 100) setPhase("lose"); return nv; });
    setTime((t) => { const nt = t + dt; if (nt >= SURVIVE) { setPhase("win"); sfx.win?.(); return SURVIVE; } return nt; });
    setTick((x) => (x + 1) % 1e6);
  });

  const b = beam.current, lit = phase === "play" && Math.abs(player.current.x - b.x) < 9;
  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Hide for" value={`${Math.ceil(SURVIVE - time)}s`} />
        <AScore label="Spotted" value={`${Math.round(det)}%`} />
      </div>
      <p className="my-2 text-sm text-kirana-brown/70">Stay in the shadows! Move to dodge the seeker's torch. If the light finds you, the meter fills.</p>
      <div data-testid="cc-arena" className="relative mx-auto mb-3 h-72 w-full max-w-md overflow-hidden rounded-md border-2 border-kirana-border bg-[#20303a]">
        <div className="absolute left-1/2 top-1 -translate-x-1/2 text-2xl">🔦</div>
        {/* torch beam */}
        {phase !== "ready" && (
          <div className="absolute top-6 h-[88%]" style={{ left: `${b.x}%`, width: "18%", transform: "translateX(-50%)", background: "linear-gradient(to bottom, rgba(255,236,150,0.75), rgba(255,236,150,0.05))", clipPath: "polygon(38% 0, 62% 0, 100% 100%, 0% 100%)" }} />
        )}
        {/* cover bushes */}
        <div className="absolute bottom-10 left-[16%] text-2xl">🌳</div>
        <div className="absolute bottom-24 left-[70%] text-2xl">🌳</div>
        <div className="absolute bottom-6 left-[45%] text-2xl">🪨</div>
        {phase !== "ready" && <Token testid="cc-player" x={player.current.x} y={player.current.y} color={lit ? "#E63946" : "#2A9D8F"} label="🙈" size={32} z={8} ring={lit} />}
        {phase === "play" && (
          <div className="absolute inset-x-3 bottom-2 h-2 overflow-hidden rounded-full bg-black/40"><div className="h-full bg-kirana-red transition-all" style={{ width: `${det}%` }} /></div>
        )}
      </div>
      {phase === "play" && <div className="flex items-center justify-center gap-4"><Joystick onMove={setJoy} /><span className="hidden text-xs text-kirana-brown/60 sm:inline">Move: WASD / Arrows</span></div>}
      <div className="mt-3">
        {phase === "ready" && <ABtn data-testid="cc-start" onClick={start} tone="gold" className="px-8 py-3">Start Hiding</ABtn>}
        {(phase === "win" || phase === "lose") && (<><AResult testId="cc-result" win={phase === "win"} text={phase === "win" ? "Kabhi na mila! You stayed hidden! 🎉" : "Mil gaya! The seeker spotted you. 🔦"} /><div className="mt-3 flex justify-center"><ABtn data-testid="cc-again" onClick={start} tone="green">Play Again</ABtn></div></>)}
      </div>
    </div>
  );
}
